import z from 'zod';
import {firestoreTimestampAdminSchema} from './firestoreTimestampAdminSchema';
import {firestoreTimestampClientSchema} from './firestoreTimestampClientSchema';
import {firestoreTimestampCreatorSchema} from './firestoreTimestampCreatorSchema';

export const firestoreTimestampSchema = z.union([
  firestoreTimestampAdminSchema,
  firestoreTimestampClientSchema,
  firestoreTimestampCreatorSchema,
]);

export type FirestoreTimestamp = z.infer<typeof firestoreTimestampSchema>;
